import styled, { css } from 'styled-components';

import { Tooltip } from './Tooltip';

import { colors } from '@10d/tend-ui-tokens/samolet';

import { TooltipProps } from './types';

export const tooltipInnerStyle = css`
  background-color: ${colors.gray900};
  border-radius: 4px;
  padding: 4px 16px;
  line-height: 24px;
  color: ${colors.gray0};
  max-width: 400px;
  box-shadow: none;
`;

export const StyledTooltip = styled(Tooltip)<TooltipProps>`
  max-width: initial;
  & .ant-tooltip-inner {
    ${tooltipInnerStyle}

    ${({ withoutBreaks }) =>
      withoutBreaks &&
      css`
        white-space: nowrap;
        max-width: inherit;
      `}
  }

  & .ant-tooltip-arrow-content {
    &::before {
      content: none;
    }

    background-color: ${colors.gray900};
  }
`;
